import React from 'react';
import Videos from './Videos';
import PlayVideo from './PlayVideo';

export default {
  path: '',

  children: [
    {
      path: '',
      async action() {
        return {
          title: 'Videos',
          chunks: ['videos'],
          component: <Videos />,
        };
      },
    },
    {
      path: '/play/:videoTitle/:playbackId/:shortLink',
      async action({ params }) {
        const title = `Video - ${params.videoTitle}`;
        return {
          title,
          component: (
            <PlayVideo
              title={title}
              shortLink={params.shortLink}
              videoTitle={params.videoTitle}
              playbackId={params.playbackId}
            />
          ),
        };
      },
    },
  ],

  async action({ next }) {
    const route = await next();
    return route;
  },
};
